import { createSlice } from "@reduxjs/toolkit";

import { getLanguages } from "./language.operations";
import {
  getLanguagesFulfilledReducer,
  getRejectedReducer,
} from "./language.reducer";
import { languageInitialState } from "./languageInitialState";

const languageSlice = createSlice({
  name: "activeLocales",
  initialState: languageInitialState,

  extraReducers: builder =>
    builder
      .addCase(getLanguages.fulfilled, getLanguagesFulfilledReducer)
      .addCase(getLanguages.rejected, getRejectedReducer),
});

export const LanguagesAction = {
  getLanguages,
};

export default languageSlice.reducer;
